module.exports = __webpack_public_path__ + "static/2-2bee8a7044c960175b35c595918de745.jpg";